import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';

import { fetchAlertsTrend as fetchAlertsTrendService } from "services/modules/vapt/data";

import CircularProgress from '@mui/material/CircularProgress';
import Chart from "react-apexcharts";


const VulnerabilityTrendAnalysis = ({ activeFilter, reportDate, categoryId, subcategory }) => {
  // use location hook
  const location = useLocation();

  // Query params
  const searchParams = new URLSearchParams(location.search);
  const selected_dimension = searchParams.get("dimension");
  
  // Redux selectors
  const companyDimensionsContainer = useSelector((state)=>state.vaptData.companyDimensions);
  const subcategories = companyDimensionsContainer.find(cat=>cat._id === categoryId)?.subcategories
  const dimensionsContainer=subcategories?.find(cat=>cat.category===subcategory)?.Dimensions
  const selectedCompanyContainer = useSelector((state) => state.auth.companyData);
  
  // State Variables
  const [vulnerabilityAnalysisChatOptions, setVulnerabilityAnalysisChatOptions] = useState(null);
  const [loading, setLoading] = useState(false);

  let chartstate = {
    options: {
      chart: {
        fontFamily: '"Montserrat", "Open Sans", sans-serif',
        height: 275,
        type: "line",
        zoom: { enabled: false },
        toolbar: { show: false }
      },
      markers: { size: 6 },
      stroke: { width: 3, curve: "smooth" },
      legend: {
        position: "top",
        markers: { width: 10, height: 10 },
      },
      tooltip: { shared: false },
      yaxis: { title: { text: "Findings Count" } },
    },
    series: [],
  };
  
  // Fetch Vulnerability trend based on on domain,category and subcategory
  const fetchVulnerablityTrendData = async () => {
    setLoading(true);
    let params = {
      domain: selectedCompanyContainer.domain,
      category: categoryId,
      subcategory: subcategory
    };
    if (activeFilter) {
      if (activeFilter === 7) {
        params.days = activeFilter;
      } else if(activeFilter ===1){
        params.weeks =30
      }
      else {
        activeFilter >= 14 ? params.weeks = activeFilter : params.months = activeFilter;
      }
    }
    if (selected_dimension) {
      const dimension = dimensionsContainer.find(dim => dim.slug === selected_dimension);
      params.dimension = dimension.id;
    }
    const response = await fetchAlertsTrendService({ params });
    const monthGraphData = response.data;
    let categories =activeFilter === 1 ? getWeekNames() :  activeFilter >= 14 ? getWeekNames() : getDateNames();
    if (activeFilter === 7) categories = getWeekNames();

    let chartSeries = [];
    if (selected_dimension) {
      const dimension = dimensionsContainer.find(dim => dim.slug === selected_dimension);
      chartSeries = dimension.subDimensions
        .filter(dim => !dim.subDimensions)
        .map(dim => ({
          name: dim.label,
          data: new Array(categories.length).fill(0),
        }));
    } else {
      chartSeries = dimensionsContainer
        .filter(dim => !!dim.subDimensions)
        .map(dim => ({
          name: dim.label,
          data: new Array(categories.length).fill(0),
        }));
    }
    chartstate.series = chartSeries;
    chartstate.series = chartstate.series.map(series => {
      const monthData = monthGraphData.find(dat => dat.dimension.label === series.name);
      if (monthData) {
        series.data = monthData.counts
          .sort((cA, cB) => new Date(cA.endDate) - new Date(cB.endDate))
          .map(count => count.count);
      }
      return series;
    });
    chartstate.options = { ...chartstate.options, xaxis: { categories } };
    setVulnerabilityAnalysisChatOptions(chartstate);
    setLoading(false);
  };

  useEffect(() => {
    if (activeFilter) {
      fetchVulnerablityTrendData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilter, selected_dimension, reportDate]);
  
  // Formats date names
  const getDateNames = () => {
    const dateStart = new Date();
    dateStart.setMonth(dateStart.getMonth() - (activeFilter - 1));
    dateStart.setDate(1);
    const dateEnd = new Date();
    const newTimeValues = [];

    while (dateEnd > dateStart || dateStart.getMonth() === dateEnd.getMonth()) {
      const formattedDate = dateStart.toLocaleString('default', { month: 'short', year: 'numeric' });
      newTimeValues.push(formattedDate);
      dateStart.setMonth(dateStart.getMonth() + 1);
    }
    return newTimeValues;
  };
  
  // Formats week names
  const getWeekNames = () => {
    if (activeFilter >= 14 || activeFilter === 7 || activeFilter ===1) {
      let timeValues = [];
      if (activeFilter === 14) {
        timeValues = ["Week 1", "Week 2"];
      } else if (activeFilter === 7) {
        timeValues = ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5", "Day 6", "Day 7"];
      } else if (activeFilter === 21) {
        timeValues = ["Week 1", "Week 2", "Week 3"];
      } else if (activeFilter === 1) {
        timeValues = ["Week 1", "Week 2", "Week 3", "Week 4"];
      } else if (activeFilter === 42) {
        timeValues = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6"];
      }
      return timeValues;
    }
  };

  return (
    <div>
      {loading ? (
               <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
               <CircularProgress size={60}/>
             </div>
      ) : vulnerabilityAnalysisChatOptions ? (
        <Chart
          options={vulnerabilityAnalysisChatOptions.options}
          series={vulnerabilityAnalysisChatOptions.series}
          type="line"
          height="250"
        />
      ) : (
        <Chart
          options={chartstate.options}
          series={chartstate.series}
          type="line"
          height="250"
        />
      )}
    </div>
  );
};

export default VulnerabilityTrendAnalysis;
